import React, { useEffect } from 'react';
import Page from '../Components/SettingsPage';
import ActionsContainer from '../../../components/ActionsContainer/ActionsContainer';
import ThemeButton from '../../../components/ThemeButton/ThemeButton';
import useMembers from '../../../hooks/useMembers';
import useAccountInfo from '../../../hooks/useAccountInfo';
import MembersTable from './MembersTable';
import useAnalytics from '../../../hooks/useAnalytics';

export default function MembersPage() {
  const analytics = useAnalytics();
  const accountInfo = useAccountInfo();
  const members = useMembers();

  useEffect(() => {
    analytics.capture('users_viewed', {});
    document.title = `Members • Hud`;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Page
      className="membersPage"
      actions={
        <ActionsContainer>
          <ThemeButton />
        </ActionsContainer>
      }
    >
      <h2>{accountInfo.data?.companyName || 'Members'}</h2>
      <MembersTable members={members.data ?? []} loading={members.isLoading} />
    </Page>
  );
}
